import * as Styled from './scroll-to-top.style';
import { LAYOUT_HEADER_HEIGHT } from 'approot/shared/layout/layout.styles';
import { isSmoothScrollSupported } from 'approot/shared/logic/scroll-fallback.utils';

type Props = {
  isVisible: boolean;
  isFluid?: boolean;
  domTargetId?: string;
  hasLeftNavigation?: boolean;
};

const ScrollToTop = ({
  isVisible,
  isFluid,
  domTargetId,
  hasLeftNavigation,
}: Props) => (
  <Styled.ScrollToTopButton
    data-selector="btn-back-to-top"
    isVisible={isVisible}
    isFluid={isFluid}
    hasLeftNavigation={hasLeftNavigation}
    type="button"
    onClick={() => {
      if (!domTargetId) {
        if (isSmoothScrollSupported()) {
          window.scrollTo({ top: 0, behavior: 'smooth' });
        } else {
          window.scrollTo(0, 0);
        }
      } else {
        const contentNavEl = document.getElementById(domTargetId);
        if (contentNavEl) {
          const y =
            contentNavEl.getBoundingClientRect().top +
            window.pageYOffset -
            LAYOUT_HEADER_HEIGHT;
          if (isSmoothScrollSupported()) {
            window.scrollTo({ top: y, behavior: 'smooth' });
          } else {
            window.scrollTo(0, y);
          }
        }
      }
    }}
  >
    Back to Top
  </Styled.ScrollToTopButton>
);

export default ScrollToTop;
